import {
  CHANGE_PARTIAL_PREMIUM_API_REQUEST,
  CHANGE_PARTIAL_PREMIUM_API_SUCCESS,
  CHANGE_PARTIAL_PREMIUM_API_ERROR,
} from '../../../constants/cartActionNames';

import { cartApi } from '../../../apis/cart';

function changePartialPremiumApiRequest() {
  return {
    type: CHANGE_PARTIAL_PREMIUM_API_REQUEST,
    payload: true,
  };
}

function changePartialPremiumApiSuccess(cart, params) {
  return {
    type: CHANGE_PARTIAL_PREMIUM_API_SUCCESS,
    payload: cart,
    params,
  };
}

function changePartialPremiumApiError(err) {
  return {
    type: CHANGE_PARTIAL_PREMIUM_API_ERROR,
    payload: err,
  };
}

export function changePartialPremiumAction(params) {
  return (dispatch, getState) => {
    const state = getState();
    const { isAuthenticated } = state.auth;
    const alpha2 = state?.locations?.yourLocation?.alpha2;
    params.alpha2 = alpha2;
    // if (!isAuthenticated) {
    //   return dispatch(deleteCartItemSuccess(params));
    // }
    dispatch(changePartialPremiumApiRequest());
    return cartApi
      .changePartialPremium(state, params)
      .then(data => {
        dispatch(changePartialPremiumApiSuccess(data, params));
        return data;
      })
      .catch(error => {
        dispatch(changePartialPremiumApiError(error));
        throw error;
      });
  };
}

export default { changePartialPremiumAction };
